import { render } from "./breadCrumb.vue?vue&type=template&id=48e6aa4f"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"

import "./breadCrumb.vue?vue&type=style&index=0&id=48e6aa4f&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-sold-detail/breadCrumb.vue'],['render',render],['__file',"breadCrumb.vue"]])

export default __exports__